import React, { Fragment, useEffect } from "react";
import TablePagination from "@mui/material/TablePagination";

const CustomPagination = ({
    currentPage,
    setCurrentPage,
    items,
    setTotalPages,
    itemsPerPage,
    setPaginatedItems,
    handleChangeRowsPerPage,
}) => {
    const rowsPerPageOptions = [5, 10, 15, 20, 25];
    useEffect(() => {
        if (items && itemsPerPage) {
            const totalItems = items.length;
            const totalPagesCount = Math.ceil(totalItems / itemsPerPage);
            setTotalPages(totalPagesCount);
        }
        if (items && itemsPerPage && currentPage === 1) {
            const startIndex = 0;
            const endIndex = Math.min(itemsPerPage, items.length);
            const initialPaginatedItems = items.slice(startIndex, endIndex);
            setPaginatedItems(initialPaginatedItems);
        }
        // eslint-disable-next-line
    }, [items, itemsPerPage, currentPage]);

    const handlePageChange = (event, newPage) => {
        const startIndex = (newPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, items.length);
        const slicedItems = items.slice(startIndex, endIndex);
        setPaginatedItems(slicedItems);
        setCurrentPage(newPage + 1);
    };

    return (
        <Fragment>
            {items.length > 5 && (
                <TablePagination
                    component="div"
                    count={items.length}
                    page={currentPage - 1}
                    onPageChange={handlePageChange}
                    rowsPerPage={itemsPerPage}
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            )}
        </Fragment>
    );
};

export default CustomPagination;
